/* AdvisoryCriticalityComponent.js */

"use strict";

//const BaseAdvisoryViewColumnComponent = require("../BaseAdvisoryViewColumnComponent");
const DefaultColumnComponent = require("@gluenetworks/steve_ui_widgets").GridGl.DefaultColumnComponent;
const Renderer = require("./AdvisoryCriticalityRenderer");
const _ = require("lodash");

class AdvisoryCriticalityComponent extends DefaultColumnComponent {
    constructor(value) {
        super(value);
        this._value = value;
        this._renderer = new Renderer(this);
        this._registerListeners();
    }

    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS   */

    /*******************************************/
    _registerListeners() {}

    _unregisterListeners() {}

    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS     */
    /* START PUBLIC COMPONENT MODEL METHODS    */

    /*******************************************/
    get renderer() {
        return this.getRenderer();
    }

    getRenderer() {
        return this._renderer;
    }

    shutdown() {
        this._unregisterListeners();
        return this._renderer._shutdown().then(() => {
            this._renderer = undefined;
            this._advisoryColumn = undefined;
        });
    }

    /*******************************************/
    /* END COMPONENT MODEL METHODS             */
    /* START HANDLER METHODS                   */
    /*******************************************/

    /*******************************************/
    /* END HANDLER METHODS                     */
    /* START PRIVATE METHODS                   */
    /*******************************************/

    /*******************************************/
    /* END PRIVATE METHODS                     */
    /* START PUBLIC API METHODS                */
    /*******************************************/

    setValue(newVal) {
        if (!_.isUndefined(newVal.advisoryColumn)) {
            this.setAdvisoryColumn(newVal.advisoryColumn);
        }
    }

    getValue() {
        return {
            advisoryColumn: this.getAdvisoryColumn()
        };
    }

    setAdvisoryColumn(newVal) {
        this._advisoryColumn = newVal;
        this.emit("AdvisoryColumn", newVal);
        return this;
    }

    getAdvisoryColumn() {
        return this._value;
    }

    /*******************************************/
    /* END PUBLIC API METHODS                  */
    /*******************************************/
}

module.exports = AdvisoryCriticalityComponent;
